import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import { capitalize } from 'lodash/string';
import moment from 'moment';
import AppIcon from '../../components/AppIcon';
import InnerHtmlContent from '../InnerHtmlContent';
import InfoTextExpandable from '../InfoTextExpandable';

const TimeSlotCard = ({ active, disabled, large, timeSlot, unit, onClick, actionElement, t, confirmationInfo }) => {
  const duration = Object.prototype.hasOwnProperty.call(timeSlot.duration, timeSlot.type) ? timeSlot.duration[timeSlot.type] : timeSlot.duration;
  const time = moment(timeSlot.timeMoment).locale(moment.locale());
  const handleClick = (e) => {
    if (e.target.className !== 'show-button' && !disabled) {
      onClick(timeSlot);
    }
  };

  return (
    <Button
      className={`time-slot-card ${large ? 'time-slot-card-large' : 'time-slot-card-small'}`}
      active={active}
      disabled={disabled}
      onClick={handleClick}
      block
      bsStyle="default"
      bsSize="large"
      key={`${timeSlot.reservation}-TimeSlotCard-Button`}
    >
      <span className="time-slot-card-flex">
        <span className="time-slot-card-left">
          <span className="time-slot-date">
            {capitalize(time.format('dd D.M.'))} {t('oClock')} {time.format('H.mm')}–
            {time.clone().add(duration, 'minutes').format('H.mm')}
            {timeSlot.hasResponsible &&
            <span>
              <AppIcon iconName="STAR" containerClass="resp-image" />
            </span>
            }
          </span>
          <span className="time-slot-info">
            { unit &&
            <span className="time-slot-unit">
              <div className="time-slot-unit-name">{unit.name}</div>
              <div className="time-slot-unit-address">{unit.address}, {unit.city}</div>
            </span>
            }
            { timeSlot &&
            <span className="time-slot-resource">
              <span className="time-slot-resource-name">{timeSlot.resourceName}</span><br />
              <span className="time-slot-speciality">{timeSlot.resourceType}</span>
            </span>
            }
          </span>
          {
            disabled 
              ? <InnerHtmlContent content={confirmationInfo} elementClass="time-slot-confirmation-info" />
              : <InfoTextExpandable text={confirmationInfo} className="time-slot-confirmation-info" />
          }
        </span>
        <span className="time-slot-card-right">
          {actionElement}
        </span>
      </span>
    </Button>
  );
};

TimeSlotCard.propTypes = {
  active: PropTypes.bool,
  disabled: PropTypes.bool,
  t: PropTypes.object.isRequired,
  large: PropTypes.bool,
  confirmationInfo: PropTypes.string,
  timeSlot: PropTypes.shape({
    timeMoment: PropTypes.instanceOf(moment).isRequired,
    unitName: PropTypes.string,
    resourceName: PropTypes.string.isRequired,
    resourceType: PropTypes.string,
    hasResponsible: PropTypes.bool,
    reservation: PropTypes.string
  }).isRequired,
  unit: PropTypes.shape({
    name: PropTypes.string.isRequired,
    address: PropTypes.string.isRequired,
    city: PropTypes.string.isRequired,
    info: PropTypes.string
  }).isRequired,
  onClick: PropTypes.func,
  actionElement: PropTypes.element.isRequired
};

TimeSlotCard.defaultProps = {
  active: false,
  confirmationInfo: '',
  disabled: false,
  large: false,
  onClick: () => {}
};

export default TimeSlotCard;



// WEBPACK FOOTER //
// ./src/components/TimeSlotCard/index.jsx